import Feedback from "./Feedback"

const obj = {}

obj.install = function (Vue) {
    //1.创建组件构造器
    const Construct = Vue.extend(Feedback)

    //2.用new 的方式用组件构造器创建出来组件对象
    const feedback = new Construct()

    //3.将组件对象手动挂载到某一个元素上
    feedback.$mount(document.createElement('div'))

    //4.feedback.$el对应的就是div
    document.body.appendChild(feedback.$el)

    //5.在原型中加入Feedback
    Vue.prototype.$Feedback = feedback

}

export default obj
